import {
  required,
  isEmail,
  isNumber,
  maxLength,
  minLength,
  isAlphabet,
  isPhoneNumber,
  isPassword,
  isChecked,
  isURL,
  isValidDate,
  isValidTime,
  isPath,
  isGST,
  isIconNameOrImage,
  isAlphanumeric,
  isCost,
} from "./Ruls";

export const validate = (formName, formData) => {
  const errors = {};

  const validationRules = {
    EnvironmentCreate: {
      environment: [required, isAlphabet, minLength(3)],
      email: [required, minLength(5), isEmail],
      age: [required, isNumber],
      firstName: [required, minLength(1), maxLength(10)],
      phoneNumber: [isPhoneNumber],
      password: [isPassword],
      is_active: [isChecked],
      active: [isChecked],
      url: [isURL],
      date: [required, isValidDate],
      duration: [isValidTime, required],
      media: [required],
      multiMedia: [required],
      multiModule: {
        type: [required],
        firstName: [required, isAlphabet, minLength(1), maxLength(10)],
        lastName: [required, isAlphabet, minLength(1), maxLength(10)],
        age: [required, isNumber],
      },
      secondMultiModule: {
        type1: [required],
        firstName1: [required, isAlphabet, minLength(1), maxLength(10)],
        lastName1: [required, isAlphabet, minLength(1), maxLength(10)],
        age1: [required, isNumber],
      },
    },
    StateCreate: {
      state_name: [required, isAlphabet],
    },
    CityCreate: {
      city_name: [required, isAlphabet],
      state_id: [required],
    },
    WarehouseCreate: {
      project_id: [required],
      state_id: [required],
      city_id: [required],
      warehouse_name: [required],
      type: [required],
    },
    RoleCreate: {
      role_name: [required, isAlphabet],
    },
    UOMCreate: {
      uom_name: [required, isAlphabet],
    },
    CategoryCreate: {
      category_name: [required],
    },
    MenuCreate: {
      menu_name: [required, isAlphabet],
      menu_icon: [isIconNameOrImage],
      menu_url: [required, isPath],
      parent_id: [required],
    },
    ItemCreate: {
      item_code: [required],
      description: [required],
      uom_id: [required],
      cost: [required, isCost],
      type: [required],
      origin: [required],
      category_id: [required],
    },
    UserCreate: {
      user_type: [required],
      first_name: [required, isAlphabet],
      last_name: [required, isAlphabet],
      role_id: [required],
      email_id: [required, isEmail],
      mobile_number: [required, isPhoneNumber],
      password: [required, minLength(6)],
      // alt_mobile_number: [isPhoneNumber],
      gst_no: [isGST],
      company_id: [required],
      // subcontractor: {
      //   first_name: [required],
      //   last_name: [required],
      //   email_id: [required, isEmail],
      //   mobile_number: [required, isPhoneNumber],
      //   password: [required, minLength(6)],
      // },
      // user_documents: {
      //   document: [required],
      //   file: [required],
      // },
    },
    InstallationCreate: {
      project_id: [required],
      customer_id: [required],
      form_name: [required],
      ref_document_no: [required, isAlphanumeric],
      po_number: [required],
    },
    StageCreate: {
      stage: [required, isAlphabet],
    },
    GSTPercentageCreate: {
      gst_percentage: [required],
    },
    CommissioningCreate: {
      customer_id: [required],
      form_name: [required, isAlphanumeric],
      ref_document_no: [required, isAlphanumeric],
    },
    ProjectCreate: {
      project_code: [required],
      customer_id: [required],
      project_name: [required],
    },
  };

  const rulesForForm = validationRules[formName];

  if (!rulesForForm) {
    return errors;
  }

  const processValidation = (rules, data, parentKey = "") => {
    for (const field in rules) {
      const fieldRules = rules[field];
      const fieldValue = data[field];
      const fullKey = parentKey ? `${parentKey}.${field}` : field;

      if (Array.isArray(fieldRules)) {
        // Validate flat fields
        for (const rule of fieldRules) {
          const errorMessage = rule(fieldValue, field);
          if (errorMessage) {
            errors[fullKey] = errorMessage;
            break;
          }
        }
      } else if (Array.isArray(fieldValue)) {
        // Special case for arrays like multiModule
        fieldValue.forEach((row, index) => {
          // Process each object in the array
          processValidation(fieldRules, row, `${fullKey}[${index}]`);
        });
      } else if (typeof fieldRules === "object") {
        // Recurse into nested objects
        processValidation(fieldRules, fieldValue || {}, fullKey);
      }
    }
  };

  processValidation(rulesForForm, formData);

  return errors;
};
